import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Tag, Spin, Tooltip } from "antd";
import { ArrowDownOutlined } from "@ant-design/icons";
import { getWorkflowTasksApi } from "../../../apiservice/ats";
import "./WorkflowTaskFlow.css";

export default function WorkflowTaskFlow() {
  const { recordType, recordId } = useParams();

  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadTasks();
  }, [recordType, recordId]);

  const loadTasks = async () => {
    setLoading(true);
    try {
      const res = await getWorkflowTasksApi({
        record_type: recordType,
        record_id: recordId,
      });

      const sortedTasks = (res.data || []).sort((a, b) => a.id - b.id);
      setTasks(sortedTasks);
    } catch (err) {
      console.error("Failed to load workflow tasks", err);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status = "") => {
    switch (status.toLowerCase()) {
      case "completed":
        return "green";
      case "pending":
        return "orange";
      case "rejected":
        return "red";
      default:
        return "gray";
    }
  };

  const getNodeDetails = (task) => {
    const graph = task.workflow_data;
    if (!graph?.nodes) return null;
    return graph.nodes.find((n) => n.id === task.node_id);
  };

  if (loading) return <Spin />;

  return (
    <div>
      <h3>
        Workflow for {recordType} #{recordId}
      </h3>

      <div className="workflow-container-vertical">
        {tasks.map((task, idx) => {
          const node = getNodeDetails(task);

          return (
            <div key={task.id} className="workflow-task-wrapper-vertical">
              <Tooltip title={`Node ID: ${task.node_id}`}>
                <div
                  className="workflow-task-vertical"
                  style={{ borderColor: getStatusColor(task.status) }}
                >
                  {/* Node Type */}
                  <div className="node-type">
                    <Tag color="blue">{node?.type?.toUpperCase()}</Tag>
                  </div>

                  {/* Node Label */}
                  <div className="node-label">
                    <b>{node?.data?.label || task.node_id}</b>
                  </div>

                  {/* Node Details */}
                  {node?.type === "condition" && (
                    <div className="node-details">
                      <b>Condition</b>
                      <ul>
                        {node.data.conditions?.map((c, i) => (
                          <li key={i}>
                            {c.field} {c.operator} {c.value}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {node?.type === "action" && (
                    <div className="node-details">
                      <b>Action:</b> {node.data.actionType}
                      {node.data.updateField && (
                        <div>
                          Update <b>{node.data.updateField}</b> →{" "}
                          {node.data.updateValue}
                        </div>
                      )}
                      {node.data.target && (
                        <div>Assigned To: {node.data.target}</div>
                      )}
                    </div>
                  )}

                  {/* Status */}
                  <Tag
                    color={getStatusColor(task.status)}
                    style={{ marginTop: 8 }}
                  >
                    {task.status.toUpperCase()}
                  </Tag>
                </div>
              </Tooltip>

              {/* Arrow */}
              {idx < tasks.length - 1 && (
                <ArrowDownOutlined className="workflow-arrow-vertical" />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
